import FileSaver from 'file-saver';

export default FileSaver;



// WEBPACK FOOTER //
// ./src/@utils/FileSaver/index.web.js